import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import { Button, Icons, MaterialPalette, Typography } from '@nutrien/cxp-components';
import localforage from 'localforage';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import SignatureCanvas from 'react-signature-canvas';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { useMst } from '../../mobx-models/Root';
import { InspectionTaskListType, ISignAndStampData } from '../../models/models';
import { useSignAndStampFile } from '../../rxdb/signAndStamp/useSignAndStampFile';
import { SignAndStampUserLevelDocument } from '../../rxdb/signAndStampUserLevel/queryBuilder';
import { useSignAndStampUserLevel } from '../../rxdb/signAndStampUserLevel/useSignAndStampUserLevel';
import { useTaskList } from '../../rxdb/taskList/useTaskList';
import { isJestTest } from '../../test-helpers/isJestTest';
import { sentryCaptureException, useFileStorage, useNotification } from '../../utilities';
import {
  ADHOC_SUBMIT_TO_SC,
  ALLOW_EXTENSIONS,
  COMPLETING_INSPECTION,
  FALSE,
  INVALID_FILE,
  INVALID_FILE_TYPE,
  SPECIAL_CHARACTER_ERROR,
  TRUE,
  UPDATING_SIGN_AND_STAMP,
} from '../../utilities/constants';
import { FileCategory, InspectorRole, Key, TaskStatus } from '../../utilities/enums';
import {
  checkFileCorruption,
  getLocalStorageCurrentUserId,
  hasSpecialCharacter,
} from '../../utilities/utilityFunctions';
import signAndStampStyles from '../SignAndStamp/SignAndStamp.styles';
import SignAndStampFIView from '../SignAndStampFIView';
import SignatureAndStampTopBar from '../UserSignatureAndStamp/SignatureAndStampTopBar';
import UserConsent from '../UserSignatureAndStamp/UserConsent';
import UserConsentMessage from './UserConsentMessage';
localforage.createInstance({
  name: 'attachment-store',
});

interface Props {
  openSignAndStamp: boolean;
  setopenSignAndStamp: (val: boolean) => void;
  inspectionData: InspectionTaskListType;
  isFISignAndStamp: boolean;
  anchorEl: HTMLButtonElement | null;
  isSignAndStampFromInspectionList: boolean;
  setComingfromSignAndStamp: (val: boolean) => void;
}

const SignAndStamp: React.FC<Props> = ({
  openSignAndStamp,
  setopenSignAndStamp,
  setComingfromSignAndStamp,
  inspectionData,
  isFISignAndStamp,
  anchorEl,
  isSignAndStampFromInspectionList,
}) => {
  const { inspectionId, isAdhoc, taskList } = inspectionData;
  const classes = signAndStampStyles();
  const signatureCanvasHeight = '500';
  const localStorageCurrentUserId = getLocalStorageCurrentUserId();
  let signatureCanvas: SignatureCanvas | null;
  const { uploadSignAndStamp, getAttachmentFromIndexDB } = useFileStorage();
  const { CurrentUserSelected } = useMst();
  const [isSignature, setIsSignature] = useState<boolean>(false);
  const [confirmationForSignAndStamp, setConfirmationForSignAndStamp] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<ISignAndStampData[]>([]);
  const [userSignData, setUserSignData] = useState<ISignAndStampData>();
  const [userStampData, setUserStampData] = useState<ISignAndStampData>();
  const [isUploadButDisable, setIsUploadButDisable] = useState<boolean>(true);
  const [isSaveCheckDisable, setIsSaveCheckDisable] = useState<boolean>(true);
  const [isSaveForFuture, setIsSaveForFuture] = useState<boolean>(false);
  const [deleteUserFiles, setDeleteUserFiles] = useState<ISignAndStampData[]>([]);
  const { successNotification, errorNotification } = useNotification();
  const [openUserConsent, setOpenUserConsent] = useState<boolean>(false);
  const [isAccepted, setIsAccepted] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [openAlert, setIsOpenAlert] = useState<boolean>(false);
  const [signData, setSignData] = useState<ISignAndStampData>();
  const [stampData, setStampData] = useState<ISignAndStampData>();
  const [disableCheckedCheckbox, setDisableCheckedCheckbox] = useState<boolean>(false);
  const [isUserConsentEnable, setIsUserConsentEnable] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const history = useHistory();

  const { deleteSignAndStampFile } = useSignAndStampFile();
  const {
    signAndStampUserLevelInitialized,
    signAndStampUserLevelCollection,
    getSignAndStampUserLevel,
  } = useSignAndStampUserLevel();
  const [signAndStampUserLevelUpdateSubscription, setSignAndStampUserLevelUpdateSubscription] =
    useState<Subscription>();
  const { updateAllTaskStatus, updateTaskStatusNewFlow, updateTaskStatusesAfterLiSign } =
    useTaskList();

  const getSignAndStampUserLevelFromRxDB = async () => {
    if (signAndStampUserLevelCollection) {
      const signAndStampUserLevelRxDocument: SignAndStampUserLevelDocument[] =
        await getSignAndStampUserLevel();
      if (signAndStampUserLevelRxDocument) {
        const signUserData = signAndStampUserLevelRxDocument.find(
          (item: SignAndStampUserLevelDocument) =>
            item.fileCategory === FileCategory.SIGN &&
            item.userId === localStorageCurrentUserId &&
            item.isSaveForFuture === true &&
            item.isDelete === FALSE,
        );
        if (signUserData) {
          const data: ISignAndStampData = {
            fileUUID: signUserData.fileUUID,
            updatedName: signUserData.name,
            category: signUserData.fileCategory,
            filePath: signUserData.originalPath,
          };
          setUserSignData(data);
        }
        const stampUserData = signAndStampUserLevelRxDocument.find(
          (item: SignAndStampUserLevelDocument) =>
            item.fileCategory === FileCategory.STAMP &&
            item.userId === localStorageCurrentUserId &&
            item.isSaveForFuture === true &&
            item.isDelete === FALSE,
        );
        if (stampUserData) {
          const data: ISignAndStampData = {
            fileUUID: stampUserData.fileUUID,
            updatedName: stampUserData.name,
            category: stampUserData.fileCategory,
            filePath: stampUserData.originalPath,
          };
          setUserStampData(data);
        }
      }
    }
  };

  const subscribeToSignAndStampUserLevel = async () => {
    if (signAndStampUserLevelInitialized && signAndStampUserLevelCollection) {
      const signAndStampUserLevelUpdateSub = signAndStampUserLevelCollection
        .find()
        .$.subscribe(() => {
          getSignAndStampUserLevelFromRxDB();
        });
      setSignAndStampUserLevelUpdateSubscription(signAndStampUserLevelUpdateSub);
    }
  };

  const onOpenUploadForSign = async () => {
    document.getElementById('selectImageForSign')?.click();
  };

  const onOpenUploadForStamp = async () => {
    document.getElementById('selectImageForStamp')?.click();
  };

  const onFilesSelected = async (images: ISignAndStampData[]) => {
    await setSelectedFiles(images);
  };

  const autoVersionIfFileExists = (name: string, index = 0): string => {
    let newName = name,
      ext = '';
    if (index) {
      if (newName.indexOf('.') > -1) {
        const tokens = newName.split('.');
        ext = '.' + tokens.pop();
        newName = tokens.join('.');
      }
      newName = `${newName} (${index})${ext}`;
    }
    const nameExists = selectedFiles.filter(f => f.updatedName === newName).length > 0;
    return nameExists ? autoVersionIfFileExists(name, index + 1) : newName;
  };

  const uploadStampImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file: File = e.target.files[0];
    if (!ALLOW_EXTENSIONS.exec(file.name)) {
      errorNotification(INVALID_FILE_TYPE);
      return;
    }
    if (hasSpecialCharacter(file.name)) {
      errorNotification(SPECIAL_CHARACTER_ERROR);
      return;
    }
    let validItem = null;
    validItem = await checkFileCorruption([file]);
    if (!validItem.length) {
      errorNotification(INVALID_FILE);
      return;
    }
    if (file) {
      const fileData = {
        fileData: file,
        updatedName: autoVersionIfFileExists(file.name),
        category: FileCategory.STAMP,
        isSignature: false,
      };
      setDisableCheckedCheckbox(false);
      setStampData(fileData);
      setSelectedFiles(arr => [...arr, ...[fileData]]);
    }
  };

  const uploadSignImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file: File = e.target.files[0];
    if (!ALLOW_EXTENSIONS.exec(file.name)) {
      errorNotification(INVALID_FILE_TYPE);
      return;
    }
    if (hasSpecialCharacter(file.name)) {
      errorNotification(SPECIAL_CHARACTER_ERROR);
      return;
    }
    let validItem = null;
    validItem = await checkFileCorruption([file]);
    if (!validItem.length) {
      errorNotification(INVALID_FILE);
      return;
    }
    if (file) {
      const fileData = {
        fileData: file,
        updatedName: autoVersionIfFileExists(file.name),
        category: FileCategory.SIGN,
        isSignature: false,
      };
      setDisableCheckedCheckbox(false);
      setSignData(fileData);
      setSelectedFiles(arr => [...arr, ...[fileData]]);
    }
  };

  const onsetDeleteUserFiles = async (data: ISignAndStampData[]) => {
    setDeleteUserFiles(data);
  };

  const handleFileDelete = async (fileId: string, fileCategory: number) => {
    switch (fileCategory) {
      case FileCategory.SIGN:
      case FileCategory.STAMP:
        await deleteSignAndStampFile(fileId.toString(), TRUE);
        onsetDeleteUserFiles(deleteUserFiles.filter(image => image.fileUUID !== fileId));
        break;
    }
  };

  const handleDelete = (file: ISignAndStampData) => {
    if (file.fileUUID) {
      if (userSignData && userSignData?.fileUUID === file.fileUUID) {
        setUserSignData(undefined);
      }
      if (userStampData && userStampData?.fileUUID === file.fileUUID) {
        setUserStampData(undefined);
      }
    } else {
      if (file.category === FileCategory.SIGN) {
        setSignData(undefined);
      } else if (file.category === FileCategory.STAMP) {
        setStampData(undefined);
      }
    }

    if (deleteUserFiles) {
      deleteUserFiles.map(image => {
        if (image.fileUUID && file.fileUUID && image.fileUUID === file.fileUUID) {
          handleFileDelete(image.fileUUID, image.category);
        }
      });
    }

    onFilesSelected(selectedFiles.filter(image => image.updatedName !== file.updatedName));
  };

  const isLiFiScSame = useMemo(() => {
    if (taskList && taskList.length > 0) {
      const task = taskList[0];
      return (
        task?.fkInspectorLead === task?.fkInspectorField &&
        task?.siteCoordinatorUserId === task?.fieldInspectorUserId
      );
    }
    return false;
  }, [taskList]);

  const handleImageUploads = async (fileList: ISignAndStampData[]) => {
    const files = [...fileList];
    files.forEach((file, index) => {
      files[index].isSaveForFuture = isSaveForFuture;
      files[index].isInspection = !isFISignAndStamp;
    });
    if (isSaveForFuture && deleteUserFiles) {
      files.forEach((file, index) => {
        deleteUserFiles.forEach((dFile, dIndex) => {
          if (files[index].updatedName === deleteUserFiles[dIndex].updatedName) {
            files[index].isSaveForFuture = false;
          }
        });
      });
    }
    try {
      await Promise.all(
        files.map(async (signAndStampData: ISignAndStampData) => {
          const fileData: File = signAndStampData.fileData as File;
          const tempData = signAndStampData;
          tempData.isInspection = !isFISignAndStamp;
          if (signAndStampData.isSaveForFuture) {
            await uploadSignAndStamp(
              `signAndStamp/${localStorageCurrentUserId}`,
              fileData,
              signAndStampData,
            );
          }
        }),
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('🚀 ~ file: signAndSigmp.tsx ~ line 350 ~ handleImageUploads ~ error', error);
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: signAndSigmpFI.tsx ~ line 415 ~ handleImageUploads ~');
    }

    try {
      await Promise.all(
        files.map(async (signAndStampData: ISignAndStampData) => {
          const fileData: File = signAndStampData.fileData as File;
          const tempData = signAndStampData;
          tempData.isSaveForFuture = false;
          tempData.isInspection = !isFISignAndStamp;
          await uploadSignAndStamp(
            `signAndStamp/${isFISignAndStamp ? CurrentUserSelected.taskId : inspectionId}`,
            fileData,
            signAndStampData,
          );
          if (!isFISignAndStamp && !isAdhoc) {
            taskList
              ?.filter(
                task =>
                  task.fkInspectorField === task.fkInspectorLead &&
                  task.fkInspectionTaskStatusCategory == TaskStatus.LI_SIGN_PENDING,
              )
              .forEach(async task => {
                tempData.isInspection = false;
                tempData.taskId = task.pkAssetInspectionTask;
                await uploadSignAndStamp(
                  `signAndStamp/${task.pkAssetInspectionTask}`,
                  fileData,
                  signAndStampData,
                );
              });
          }
        }),
      );

      let result = null;
      if (isAdhoc) {
        result = await updateAllTaskStatus(
          Number(inspectionId),
          isLiFiScSame ? TaskStatus.COMPLETED : TaskStatus.SC_PENDING_APPROVAL,
          InspectorRole.LEAD,
        );
      } else {
        if (isFISignAndStamp) {
          const selectedTask = taskList?.find(
            task => task.pkAssetInspectionTask === CurrentUserSelected.taskId,
          );
          result = await updateTaskStatusNewFlow(
            CurrentUserSelected.taskId,
            selectedTask?.fkInspectorLead === selectedTask?.fkInspectorField &&
              selectedTask?.siteCoordinatorUserId === selectedTask?.fieldInspectorUserId
              ? TaskStatus.COMPLETED
              : TaskStatus.LI_PENDING_APPROVAL,
          );
        } else {
          result = await updateTaskStatusesAfterLiSign(Number(inspectionId));
        }
      }

      if (result) {
        setTimeout(() => {
          setopenSignAndStamp(false);
          successNotification('Sign and Stamp Submitted Successfully');
          setIsLoading(false);
        }, 100);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('🚀 ~ file: signAndSigmp.tsx ~ line 369 ~ handleImageUploads ~ error', error);
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: signAndSigmp.tsx ~ line 369 ~ handleImageUploads ~');
    }
  };

  const getSignature = async () => {
    const val = signatureCanvas?.toDataURL();
    const blob = await fetch(val as string).then(r => r.blob());
    const objectURL = URL.createObjectURL(blob);
    const fileName = 'sign.png';
    const file = new File([objectURL], `${fileName}`, { type: 'image/png' });
    const fileData = {
      fileData: file,
      updatedName: autoVersionIfFileExists(file.name),
      category: FileCategory.SIGN,
      isSignature: true,
      isSaveForFuture,
      blob,
    };
    return fileData;
  };

  const handleSignAndStamp = async () => {
    if (isSignature) {
      const fileData = await getSignature();
      selectedFiles.push(fileData);
    }
    await handleImageUploads(selectedFiles);
  };

  const editImageFile = async (dataURL: string, fileName: string) => {
    const blobUrl = isJestTest() ? '' : await (await fetch(dataURL)).blob();
    const file = new File([blobUrl], `${fileName}`, { type: 'image/jpeg' });
    return file;
  };

  const getS3URL = async (fileId: string) => {
    const blobFile: Blob = (await getAttachmentFromIndexDB(fileId)) as Blob;
    const url = blobFile ? URL.createObjectURL(blobFile) : '';
    return url;
  };

  const setUrlToFile = async (data: ISignAndStampData) => {
    const url = await getS3URL(data.fileUUID as string);
    if (url !== '') {
      const file = await editImageFile(url, data.updatedName);
      const fileData: ISignAndStampData = {
        fileUUID: data.fileUUID,
        fileData: file as File,
        updatedName: data.updatedName,
        category: data.category,
        isSignature: false,
        isSaveForFuture: false,
      };
      setSelectedFiles(prevArr => {
        const filteredArr = prevArr.filter(item => item.fileUUID !== fileData.fileUUID);
        return [...filteredArr, ...[fileData]];
      });
      setDeleteUserFiles(prevArr => {
        const filteredArr = prevArr.filter(item => item.fileUUID !== fileData.fileUUID);
        return [...filteredArr, ...[fileData]];
      });
    }
  };

  useEffect(() => {
    //user consent hyperlink enable/disable
    if (signData || isSignature || stampData) {
      setIsUserConsentEnable(true);
      setDisableCheckedCheckbox(false);
    } else if (!signData && !isSignature && !stampData) {
      setIsUserConsentEnable(false);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    //upload button
    if (signData || isSignature || userSignData) {
      setIsUploadButDisable(false);
    } else if (!signData && !isSignature && !userSignData) {
      setIsUploadButDisable(true);
    }
  }, [isSignature, signData, stampData, userSignData]);

  useEffect(() => {
    //user consent checkbox enbale/disable
    if (signData || isSignature || stampData) {
      setIsSaveCheckDisable(false);
    } else if (!signData && !isSignature && !stampData) {
      setIsSaveCheckDisable(true);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    //consent checkbox check
    if (!signData && !isSignature && !stampData && isChecked) {
      setIsChecked(false);
    }
  }, [isSignature, signData, stampData]);

  useEffect(() => {
    setIsSaveForFuture(isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (!isSignature && userSignData) {
      setIsUploadButDisable(false);
      setDisableCheckedCheckbox(true);
    }
  }, [isSignature, userSignData, userStampData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked === false) {
      setIsAccepted(false);
    }
    if (e.target.checked === true) {
      setIsAccepted(false);
    }
    if (isAccepted) {
      setIsChecked(e.target.checked);
      setIsOpenAlert(false);
    } else if (e.target.checked === true) {
      if (isAccepted) setIsOpenAlert(false);
      else setIsOpenAlert(true);
    } else if (!isAccepted) {
      setIsOpenAlert(true);
    }
  };

  useEffect(() => {
    if (userSignData || userStampData) {
      if (userSignData && userSignData.fileUUID) {
        setUrlToFile(userSignData);
      }
      if (userStampData && userStampData.fileUUID) {
        setUrlToFile(userStampData);
      }
    }
  }, [userSignData, userStampData]);

  useEffect(() => {
    if (signAndStampUserLevelInitialized) {
      getSignAndStampUserLevelFromRxDB();
      subscribeToSignAndStampUserLevel();
    }
    return () => {
      if (signAndStampUserLevelUpdateSubscription)
        signAndStampUserLevelUpdateSubscription.unsubscribe();
    };
  }, [signAndStampUserLevelInitialized]);

  useEffect(() => {
    if (!isFISignAndStamp && inspectionData.isLIstampingRequired && !userStampData) {
      if (!stampData) {
        setIsUploadButDisable(true);
      }
    }
  }, [
    signData,
    isSignature,
    stampData,
    inspectionData.isLIstampingRequired,
    userStampData,
    userSignData,
  ]);

  useEffect(() => {
    if (!signData && !stampData && !isSignature && !userSignData && !userStampData) {
      setIsUploadButDisable(true);
      setIsUserConsentEnable(false);
      setIsChecked(false);
    }
  }, [signData, stampData, isSignature, userSignData, userStampData]);

  const handleKeyEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === Key.Enter && !isUploadButDisable) {
      setConfirmationForSignAndStamp(true);
      setIsUploadButDisable(true);
      setIsSaveCheckDisable(true);
    }
  };

  return (
    <>
      <Dialog
        data-testid="sign-and-stamp-dialog"
        id={uuidv4()}
        fullScreen
        open={openSignAndStamp}
        onClose={() => setopenSignAndStamp(false)}
        onKeyUp={handleKeyEvent}
        maxWidth="lg"
        disableEnforceFocus
      >
        <DialogTitle id="alert-dialog-title" className={classes.paper}>
          {!isAdhoc ? (
            <SignatureAndStampTopBar
              open={openSignAndStamp}
              onClose={() => {
                setopenSignAndStamp(false);
                if (!isSignAndStampFromInspectionList) history.push('/complete-inspection');
                else {
                  history.push('inspection-list');
                }
              }}
              anchorEl={anchorEl}
              id="user-menu"
              title={
                !isAdhoc
                  ? isFISignAndStamp
                    ? 'FI Signature & Stamp'
                    : 'LI Signature & Stamp'
                  : 'Sign & Stamp'
              }
            />
          ) : (
            <Grid container xs={12} className={classes.titleAdhoc}>
              <Grid item xs={10} className={classes.titleGrid1}>
                <Typography variant="h5">Sign & Stamp</Typography>
              </Grid>
              <Grid item xs={2} className={classes.iconGridAdhoc}>
                <Icons.XFeather color="primary" onClick={() => setopenSignAndStamp(false)} />
              </Grid>
            </Grid>
          )}
        </DialogTitle>
        <DialogContent className={classes.signAndStampContent}>
          <Grid
            xs={12}
            container
            className={isAdhoc ? classes.signStampContainerAdhoc : classes.signStampContainer}
          >
            <Grid item xs={6} className={classes.signandStampTitleGrid}>
              {isAdhoc ? (
                <Typography variant="h3">Signature and Stamping</Typography>
              ) : (
                <>
                  {' '}
                  <Typography variant="h3">Signature *</Typography>
                  <span className={classes.signAndStampNote}> (signature is mandatory)</span>
                </>
              )}
            </Grid>
            <Grid item xs={12} className={classes.signatureContainer}>
              {userSignData && (
                <SignAndStampFIView data={userSignData} onDelete={handleDelete} readonly={false} />
              )}
              {signData && (
                <SignAndStampFIView data={signData} onDelete={handleDelete} readonly={false} />
              )}
              {!userSignData && !signData && (
                <>
                  {isSignature && (
                    <Grid
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                      className={classes.signStampTitle1}
                    >
                      <Typography
                        variant="h5"
                        color="error"
                        className="clearSignText"
                        onClick={() => {
                          signatureCanvas?.clear();
                          setIsSignature(false);
                        }}
                        data-testid="clearSign"
                      >
                        Clear Sign
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    {!isJestTest() ? (
                      <SignatureCanvas
                        ref={ref => {
                          signatureCanvas = ref;
                        }}
                        penColor={`${MaterialPalette.text.disabled}`}
                        backgroundColor="#404040"
                        canvasProps={{
                          height: signatureCanvasHeight,
                          className: classes.signCanvas,
                          style: { maxWidth: '100%', borderRadius: '4px' },
                        }}
                        onBegin={() => {}}
                        onEnd={() => {
                          setDisableCheckedCheckbox(false);
                          setIsSignature(true);
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </>
              )}
              {!isSignature && !userSignData && !signData && (
                <Grid item container justifyContent="center" className={classes.signLabelDiv}>
                  <Typography className={classes.signLabel}>
                    {`Digitally sign above to complete this inspection `}
                  </Typography>
                  <Typography className={classes.signLabel}>{`OR `}</Typography>
                  <Grid item className={classes.signUploadButDiv}>
                    <Button
                      color="primary"
                      className={classes.signUploadButton}
                      noMinHeight
                      onClick={onOpenUploadForSign}
                      data-testid="upload-sign-file"
                    >
                      <Grid className={classes.uploadButtonSignGrid}>
                        <Typography variant="subtitle2" className="uploadButtonsign">
                          Upload Signature
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            id="selectImageForSign"
                            onClick={() => {}}
                            onChange={uploadSignImage}
                            data-testid="upload-sign-file-li"
                          />
                        </Typography>
                      </Grid>
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
            {!isAdhoc && (
              <Grid item xs={6} className={classes.stampTitleGrid}>
                <Typography variant="h3">Stamp</Typography>
              </Grid>
            )}
            <Grid item xs={12} className={classes.stampContainer}>
              {!userStampData && !stampData && (
                <Grid container className={classes.stampUploadContainer}>
                  <Grid container justifyContent="center">
                    <Grid className={classes.stampLabelDiv}>
                      <Typography>
                        Select and Upload the Stamping Image
                        {!isFISignAndStamp && inspectionData.isLIstampingRequired ? '*' : ''}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      justifyContent="center"
                      item
                      onClick={onOpenUploadForStamp}
                      className={classes.uploadIconGrid}
                    >
                      <Icons.UploadFeather color="primary" height="40px" width="40px" />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        id="selectImageForStamp"
                        onClick={() => {}}
                        onChange={uploadStampImage}
                        data-testid="upload-stamp-file-li"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {userStampData && (
                <SignAndStampFIView data={userStampData} onDelete={handleDelete} readonly={false} />
              )}
              {stampData && (
                <SignAndStampFIView data={stampData} onDelete={handleDelete} readonly={false} />
              )}
            </Grid>
          </Grid>
          {!isAdhoc && (
            <UserConsentMessage
              handleChange={handleChange}
              openAlert={openAlert}
              isSaveCheckDisable={isSaveCheckDisable}
              isChecked={isChecked}
              disableCheckedCheckbox={disableCheckedCheckbox}
              isUserConsentEnable={isUserConsentEnable}
              setOpenUserConsent={setOpenUserConsent}
            />
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {isAdhoc ? (
            <Grid
              container
              xs={12}
              justifyContent="flex-end"
              alignItems="center"
              className={classes.dialogDivAdhoc}
            >
              <UserConsentMessage
                handleChange={handleChange}
                openAlert={openAlert}
                isSaveCheckDisable={isSaveCheckDisable}
                isChecked={isChecked}
                disableCheckedCheckbox={disableCheckedCheckbox}
                isUserConsentEnable={isUserConsentEnable}
                setOpenUserConsent={setOpenUserConsent}
              />
              <Grid item xs={2} className={classes.floatRightGrid} alignContent="flex-end">
                <Button
                  id=" "
                  disabled={isUploadButDisable}
                  noMinHeight
                  color="primary"
                  variant="contained"
                  className="signAndStampUploadButton"
                  onClick={() => setConfirmationForSignAndStamp(true)}
                  isLoading={false}
                  data-testid="sign-and-stamp-FI-upload"
                >
                  <Grid className={classes.accordianButtonLabelGrid}>
                    <Typography className="accordianButtonLabel">Confirm & Send</Typography>
                  </Grid>
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container xs={12} className={classes.dialogDiv}>
              <Grid item xs={1} className={classes.cancelButton}>
                <Button
                  variant="outlined"
                  noMinHeight
                  color="primary"
                  onClick={() => {
                    setopenSignAndStamp(false);
                    if (!isSignAndStampFromInspectionList) history.push('/complete-inspection');
                    else {
                      history.push('inspection-list');
                    }
                    setComingfromSignAndStamp(true);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={9}></Grid>
              <Grid item xs={2} className={classes.floatRightGrid} alignContent="flex-end">
                <Button
                  id=" "
                  disabled={isUploadButDisable}
                  noMinHeight
                  color="primary"
                  variant="contained"
                  className="signAndStampUploadButton"
                  onClick={() => setConfirmationForSignAndStamp(true)}
                  isLoading={false}
                  data-testid="sign-and-stamp-FI-upload"
                >
                  <Grid className={classes.accordianButtonLabelGrid}>
                    <Typography className="accordianButtonLabel">Confirm & Send</Typography>
                  </Grid>
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
      {confirmationForSignAndStamp && (
        <Dialog
          onClose={() => setConfirmationForSignAndStamp(false)}
          open={confirmationForSignAndStamp}
          title="Confirmation"
          maxWidth="xs"
        >
          <DialogContent>
            <Grid container className={classes.confirmationContainer}>
              <Grid item container xs={12} alignItems="center">
                <Typography className={classes.dialogText}>
                  {isAdhoc
                    ? isLiFiScSame
                      ? COMPLETING_INSPECTION
                      : ADHOC_SUBMIT_TO_SC
                    : UPDATING_SIGN_AND_STAMP}
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container justifyContent="space-between" spacing={2}>
              <Grid item>
                <Button
                  data-testid="cancel-sign-and-stamp-upload"
                  variant="outlined"
                  color="primary"
                  noMinHeight
                  onClick={() => {
                    setConfirmationForSignAndStamp(false);
                    setIsSaveCheckDisable(false);
                    setIsUploadButDisable(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item className={classes.confirmButtonDiv}>
                <Button
                  data-testid="save-sign-and-stamp-upload"
                  isLoading={isLoading}
                  variant="contained"
                  color="primary"
                  noMinHeight
                  onClick={() => {
                    handleSignAndStamp();
                    setSelectedFiles([]);
                    setIsLoading(true);
                  }}
                >
                  Yes, Send
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
      {openUserConsent && (
        <UserConsent
          open={openUserConsent}
          onClose={() => setOpenUserConsent(false)}
          setIsAccepted={setIsAccepted}
          setIsChecked={setIsChecked}
          setIsOpenAlert={setIsOpenAlert}
        />
      )}
    </>
  );
};

export default SignAndStamp;
